import * as React from 'react';

import {
    Container,
    CustomPIXIComponent,
} from "react-pixi-fiber";
import { connect } from 'react-redux';

import { IClip } from '../../api';
import { saveClip } from '../../thunks';
import { RootState } from '../../types';
import Clip from './Clip';

interface IOwnProps {
    duration: number | null,
    offsetX: number,
    recordingId: string | null,
    zoom: number,
}

type IProps = {
    clips: IClip[],
    onClip: (c: IClip) => void,
} & IOwnProps

interface IBGProps {
    duration: number,
    zoom: number,
    offsetX: number,
}

interface ICursorProps {
    t: number,
    zoom: number,
    offsetX: number,
}

export const BookmarksCursor = CustomPIXIComponent<ICursorProps, PIXI.Graphics>({
    customApplyProps: (instance, _2, props) => {
        const {
            t,
            zoom,
            offsetX,
        } = props;

        const x = t * zoom + offsetX;

        instance.clear();
        instance.lineStyle(0.05, 0x333333, 0.8);
        instance.moveTo(x, 85);
        instance.lineTo(x, 125);
    },
    customDisplayObject: () => new PIXI.Graphics(),
}, 'BookmarksCursor');

export const BookmarksBG = CustomPIXIComponent<IBGProps, PIXI.Graphics>({
    customApplyProps: (instance, _2, props) => {
      const {
        duration,
        zoom,
        offsetX,
      } = props;

      const width = duration * zoom;

      instance.clear();
      instance.beginFill(0xEEEEEE);
      instance.drawRect(offsetX, 85, width, 40);
      instance.endFill();
    },
    customDisplayObject: () => new PIXI.Graphics(),
}, 'BookmarksrBG');

interface IState {
    newClip: IClip | null,
    cursorPosition: number | null,
    hover: boolean,
}

export class Bookmarks extends React.Component<IProps, IState> {

    public state: IState = {
        cursorPosition: null,
        hover: false,
        newClip: null,
    }

    private container: PIXI.Container | null;
    
    public render() {
        const {
            clips,
            duration,
            offsetX,
            zoom,
        } = this.props;
        const {
            cursorPosition,
            hover,
            newClip,
        } = this.state;

        return (<Container
            ref={this.onRef}
            interactive={true}>
            <BookmarksBG zoom={zoom} offsetX={offsetX} duration={duration} />
            { newClip ? <Clip zoom={zoom} offsetX={offsetX} interactive={false} clip={newClip} /> : null }
            { clips.map(c => <Clip key={`${c.start}-${c.duration}`} zoom={zoom} offsetX={offsetX} clip={c} />) }
            { (cursorPosition && hover) ? <BookmarksCursor zoom={zoom} offsetX={offsetX} t={cursorPosition} /> : null }
        </Container>);
    }

    private onRef = (ref: any) => {
        // HACK
        const container = ref as (PIXI.Container | null);
        if (!container) { return; }

        this.container = container;

        container.on('mousedown', this.onMouseDown);
        container.on('mousemove', this.onMouseMove);
        container.on('pointerover', this.onPointerOver);
        container.on('pointerout', this.onPointerOut);
        container.on('mouseup', this.onMouseUp);
    }

    private onMouseDown = (e: PIXI.interaction.InteractionEvent) => {
        const {
            zoom,
            offsetX,
        } = this.props;

        if (!this.container) {
            return;
        }

        const {x} = e.data.getLocalPosition(this.container);
        const t = (x - offsetX) / zoom;

        this.setState({
            newClip: {
                start: t,
            }
        });
    }

    private onPointerOut = (e: PIXI.interaction.InteractionEvent) => {
        this.setState({
            hover: false,
        });
    }

    private onPointerOver = (e: PIXI.interaction.InteractionEvent) => {
        this.setState({
            hover: true,
        });
    }

    private onMouseMove = (e: PIXI.interaction.InteractionEvent) => {
        const {
            zoom,
            offsetX,
        } = this.props;

        if (!this.container) {
            return;
        }

        const {x} = e.data.getLocalPosition(this.container);
        const t = (x - offsetX) / zoom;

        this.setState({
            cursorPosition: t,
        });
        
        const {newClip} = this.state;
        if (!newClip) {
            return;
        }
        if (!newClip.start) {
            return;
        }

        // TODO: cleanup
        if (t > newClip.start) {
            this.setState({
                newClip: {
                    ...newClip,
                    duration: t - newClip.start,
                }
            });
        } else if (newClip.duration) {
            const end = newClip.start + newClip.duration;
            this.setState({
                newClip: {
                    ...newClip,
                    duration: end - t,
                    start: t,
                }
            });
        } else {
            this.setState({
                newClip: {
                    ...newClip,
                    duration: newClip.start - t,
                    start: t,
                }
            });
        }
    }

    private onMouseUp = (e: PIXI.interaction.InteractionEvent) => {
        const {
            onClip,
            recordingId,
        } = this.props;
        const {newClip} = this.state;

        const text = prompt("Describe this clip");
        if (!text) {
            this.setState({newClip: null});
            return;
        }

        if (newClip && recordingId) {
            newClip.text = text;
            newClip.recording_id = recordingId;

            onClip(newClip);
        }

        this.setState({
            newClip: null,
        });
    }

}

export const BookmarksContainer = connect(
    ({clips}: RootState, {recordingId}: IOwnProps) => ({
        clips: Object.keys(clips.data).map(id => clips.data[id]).filter(c => c.recording_id === recordingId),
    }),
    dispatch => ({
        onClip: (clip: IClip) => { dispatch<any>(saveClip(clip)) },
    }),
)(Bookmarks);

export default BookmarksContainer;



// WEBPACK FOOTER //
// ./src/components/Player/Bookmarks.tsx